import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import c from '../../constants/Colors';
import Pagination from '../reusable/Pagination'
import { data } from '../../constants/Constants';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { AgregarProductoFavorito, ListarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import ModalAddCart from "../reusable/modals/AddCart";
import ModalImageZoom2 from '../reusable/modals/ImageZoom2';
import { AuthContext } from "../../store/provider/AuthProvider";
import CardPrecios from '../reusable/CardPrecios';
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import Spinner from "../reusable/Loader";

const Card = ({ item, event, eventCounter, eventFavorito, auth, zoom }) => {
  return (
    <div className="card_product_vertical card_deseo">
      <div style={{ cursor: 'pointer' }} onClick={() => zoom(item.fotos)}>
        <img className="product-img" src={item.pathImage} />
      </div>
      <h6 className="paragraph-2 bold" style={{ color: c.naranja }}>{item.maktx}</h6>
      <span className="paragraph-3 sku">SKU: {item.matnr}</span>
      <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />
      {/* <span className="paragraph-3 previousPrice">{item.precioPublico}</span>
      <span className="paragraph-3 bold" style={{ color: c.naranja }}>{item.precioPVD}</span>
      <span className="paragraph-3">{item.precioPVP}</span> */}
      <div className="counter">
        <CounterInput
          IdInput={item.idInput}
          background={"#fff"}
          color={"#316ACD"}
          borderColor={"#E2E2E2"}
          data={item}
          eventCounter={eventCounter}
        />
      </div>
      <div className="options">
        <button className="btn-icon"
          type="button"
          onClick={() => eventFavorito({
            codigo: item.matnr, descripcion: item.maktx,
            moneda: item.waers, pantalla: data.Pantalla.Favoritos.Producto
          }, item.favorito, item.indice)}
        >
          <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
        </button>
        <button className="btn-icon"
          type="button"
          disabled={item.cantidad == 0}
          onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
            codigo: item.matnr,
            descripcion: item.maktx,
            precioOferta: item.poferta,
            precioPublico: item.plista,
            precioFinal: item.pfinal,
            precioPVD: item.precioPVD,
            precioPVP: item.precioPVP,
            precioPublico: item.precioPublico,
            unidadMedida: item.meins,
            moneda: item.waers,
            waersS: item.sWaers,
            cantidadOriginal: item.cantidad,
            cantidad: item.cantidad,
            pathI: item.pathImage,
            precios: item.precios,
            indice: item.indice,
            pantalla: data.Pantalla.Favoritos.Producto,
            escalas: item.escalas
          })}
        >
          <SvgAssets icon="icon-add-cart" className="add-cart" />
        </button>
      </div>
    </div>
  )
}

export class ListaDeseos extends Component {
  static displayName = ListaDeseos.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dealer: {},
      linea: {},
      asociado: {},
      page: 1,
      size: data.PageSize,
      currentPage: 1,
      dataResult: [],
      alertas: [],
      addToCart: false,
      dataToCard: {},
      modalZoom: false,
      imgZoom: "",
      listImgZoom: [],
    };
  }
  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: Array.isArray(img) ? "" : img,
      listImgZoom: Array.isArray(img) ? img : [],
    }));
  }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }
  componentDidUpdate(prevProps, prevState) {

  }

  load = () => {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true, dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
      this.postListarProductoFavorito(data.dealer, data.linea, data.asociado, 1);
    })
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.load();
    } else
      window.location.href = "/";
  }

  render() {
    const { page, size, currentPage, loading, dataResult, alertas } = this.state;
    const auth = this.context;
    return (
      <div className="gradient_blue_white" id="mhw" style={{ minHeight: 'calc(100vh - 69px)' }}>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Lista de Deseos</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Lista de Deseos</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <div className="card_desktop">
            <div className="desktop">
              <TooltipLeyenda
                color={c.azulClaro}
                style={{ top: -15, position: 'relative', width: 32, marginLeft: 'auto' }}
              />
            </div>
            <h6 className="title white mobile">
              <Link to='/dashboard' className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>
              Lista de deseos
              <TooltipLeyenda
                color={'#fff'}
                style={{ position: 'absolute', right: 0, top: -2 }}
              />
            </h6>
            <div className="cards-wrap container_1000">
              {dataResult.map((item, index) => {
                return (
                  <Card
                    key={index}
                    item={item}
                    eventFavorito={this.postAgregarProductoFavorito}
                    eventCounter={this.setCounter}
                    event={this.postAgregarProductoPedido}
                    auth={auth}
                    zoom={this.toggleModalZoom} />
                )
              })}
            </div>
            {/* <Pagination /> */}
            {(dataResult.length > 0) ? <Pagination event={this.setPage} current={page} currentPage={currentPage} totalPage={dataResult[0].totalPage} size={data.PageSizePaginator} /> : null}
          </div>
        </Container>
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalImageZoom2 dadComponent={this} />
      </div>
    );
  }

  setPage = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index })

    // let selectedVehiculo = this.state.filtroVehiculo.filter(p => p.id == this.state.selectedVehiculoValue)[0];
    // this.postBuscarSistema(this.state.dealer, this.state.linea, selectedVehiculo, index);
    this.postListarProductoFavorito(this.state.dealer, this.state.linea, this.state.asociado, index);
  }


  postListarProductoFavorito = async (dealer, linea, asociado, pageindex) => {
    this.setState({ loading: true })
    ListarProductoFavorito(linea.centro, dealer.codcliente,
      asociado.moneda, linea.vkorg,
      asociado.poblacion, dealer.correoElectronico,
      linea.linea, pageindex)
      .then(result => {
        if (result.mo.type == "success") {
          console.log(result.dto.repuestos);
          this.setState({
            loading: false,
            dataResult: result.dto.repuestos,
            alertas: result.dto.alertas
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Lista de deseos", error.message ?? null);
        });
      });
  }
  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, producto) => {
    this.setState({ loading: true })
    AgregarProductoPedido(this.state.dealer, producto, this.state.linea, this.state.asociado)
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(result.dto.carritoProdctos);
          this.setState({
            loading: false,
            addToCart: true,
            dataToCard: producto
          }, () => {
            this.postAgregarProductoFavorito(producto, true, producto.indice)
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }
  postAgregarProductoFavorito = async (producto, AplicaFavorito, index) => {
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito)
      .then(result => {
        debugger;
        if (result.mo.type == "success") {


          if (this.state.dataResult.length == 1 && this.state.page == 1) {
            this.setState({
              loading: false,
              dataResult: [],
              page: 1
            })
          } else if (this.state.dataResult.length == 1 && this.state.page > 1) {
            let _page = this.state.page;
            this.setState({
              page: _page - 1
            })
            this.postListarProductoFavorito(this.state.dealer, this.state.linea, this.state.asociado, this.state.page);
          } else {
            this.postListarProductoFavorito(this.state.dealer, this.state.linea, this.state.asociado, this.state.page);
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }
  setCounter = (counter, tab, index) => {
    if (counter == "") return;
    let _data = this.state.dataResult
    _data[index].cantidad = counter;

    this.setState({
      dataResult: _data,
    })

  }
}
